import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Link, useParams } from 'react-router-dom';

import Button from 'components/Button';
import Container from 'components/Container';

import { getGpt } from 'api/gpts';
import Page from 'components/Layout/Page';

export default function Detail() {

    const { gptId } = useParams();
    const { data: gpt, isLoading } = useQuery({
        queryKey: ['gpts', gptId],
        queryFn: async () => await getGpt({id: gptId}),
        enabled: Boolean(gptId),
    });

    return (
        <>
            <Page isLoading={isLoading}>
                <Container>
                    <div className='pb-8 pt-20 md:pt-14 flex justify-between items-center'>
                        <div className='flex gap-3 items-center'>
                            <Link to={`/settings/gpts/`} className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <div>
                                <p className='text-sm font-semibold'>{gpt?.slug}</p>
                                <p className='text-2xl uppercase'>{gpt?.name}</p>
                            </div>
                        </div>
                        
                        <Button to={`/settings/gpts/${gpt?._id}/edit`}>
                            Modifica
                        </Button>
                    </div>

                    <div className='flex gap-10'>
                        <div className='flex-1 border border-light rounded-sm'>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Nome</label>
                                <p className='text-muted'>{gpt?.name || "Nessun nome"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Slug</label>
                                <p className='text-muted'>{gpt?.slug || "Nessun slug"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>APIKEY</label>
                                <p className='text-muted'>{gpt?.apiKey || "Nessuna APIKEY rilevata"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Url</label>
                                <p className='text-muted'>{gpt?.url || "Nessun url"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Abilitato</label>
                                <p className='text-muted'>{gpt?.enabled ? "Sì" : "No"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Pubblico</label>
                                <p className='text-muted'>{gpt?.public ? "Sì" : "No"}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Tipologia</label>
                                <p className='text-muted'>{gpt?.type || "Nessuna tipologia"}</p>
                            </div>
                        </div>
                    </div>
                </Container>
            </Page>
        </>
    )
}
